import { useEffect, useState } from 'react';
import { UserSetup } from './UserSetup';

export type AutoUserSetupProps = {
  children: React.ReactNode;
};

export function AutoUserSetup(props: AutoUserSetupProps) {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <>
      {props.children}
      <UserSetup open={open} setOpen={setOpen} />
    </>
  );
}
